export default __webpack_public_path__ + "static/media/bgDeskOcker.0b21005d.svg";